import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access',
  template: `
    <div style="text-align:center; margin-top:100px;">
      <h2>Acceso restringido</h2>
      <input [(ngModel)]="password" placeholder="Password" type="password"/>
      <br><br>
      <button (click)="login()">Entrar</button>
      <p *ngIf="error" style="color:red;">Password incorrecto</p>
    </div>
  `
})
export class AccessComponent {

  password: string = '';
  error: boolean = false;

  private ACCESS_PASSWORD = 'NINA-2026-SS';

  constructor(private router: Router) {}

  login() {
    const ONE_DAY = 24 * 60 * 60 * 1000;
    if (this.password === this.ACCESS_PASSWORD) {
      StorageWithExpiry.set('APP_ACCESS', 'granted', ONE_DAY);
      this.router.navigate(['/home']);
    } 
    else {
      alert("Clave de acceso erronea")
      this.error = true;
    }
  }
}

export class StorageWithExpiry {
  static set(key: string, value: any, ttl: number): void {
    const now = new Date();

    const item = {
      value: value,
      expiry: now.getTime() + ttl
    };

    localStorage.setItem(key, JSON.stringify(item));
  }

  static get(key: string): any | null {
    const itemStr = localStorage.getItem(key);

    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    } catch (e) {
      console.error('Error parsing storage', e);
      return null;
    }
  }

  static remove(key: string): void {
    localStorage.removeItem(key);
  }
}